import Image from 'next/image'
import Link from 'next/link'
import type { DocsLocale } from '@/lib/docs-i18n'
import { DOCS_CHROME } from '@/lib/docs-i18n'
import { DocsSectionLink } from '@/components/docs/DocsSectionLink'

/** Logo + "/ Docs" row — shared by sidebar (desktop) and mobile subnav. */
export function DocsBrandRow({
  locale,
  className = '',
}: {
  locale: DocsLocale
  className?: string
}) {
  const chrome = DOCS_CHROME[locale]

  return (
    <div className={`docs-brand-row min-w-0 ${className}`.trim()}>
      <Link href="/" aria-label="ByteGate" className="docs-brand-logo-link shrink-0">
        <Image
          src="/ByteGate-logo-rectangle-lightmode.svg"
          alt="ByteGate"
          width={96}
          height={32}
          className="docs-brand-logo-light h-8 w-24 shrink-0"
        />
        <Image
          src="/ByteGate-logo-rectangle-darkmode.svg"
          alt=""
          width={96}
          height={32}
          aria-hidden
          className="docs-brand-logo-dark h-8 w-24 shrink-0"
        />
      </Link>
      <DocsSectionLink
        locale={locale}
        className="docs-brand-section-link truncate text-h5 font-semibold text-foreground font-sans leading-tight transition-colors"
      >
        / {chrome.sectionLabel}
      </DocsSectionLink>
    </div>
  )
}
